export const VALIDATE_TEXT_TYPE = 'text';

export const VALIDATE_EMAIL_TYPE = 'email';

export const VALIDATE_GOOGLE_AUTOCOMPLETE_ADDRESS_TYPE =
  'google-autocomplete-address';
